import { useMemo, useState } from 'react';
import { Box, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { CustomButton, CustomAutoComplete } from '../../../common/components';
import BeneficiaryDialog from './BeneficiaryDialog';

const getDisplayName = (entity) =>
  entity?.legal_business_name || entity?.company || entity?.cuit || 'Sin nombre';

const BeneficiarySelectWithCreate = ({
  label = 'Beneficiario',
  name = 'uuid_legal_entity',
  value,
  onChange,
  legalEntities = [],
  error,
  helperText,
  disabled = false,
  required = false,
  placeholder = 'Seleccionar',
  selectSx,
  containerSx,
  width = '622px',
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [localOptions, setLocalOptions] = useState([]);

  const mergedOptions = useMemo(() => {
    const knownIds = new Set(legalEntities.map((entity) => entity.uuid));
    const merged = [
      ...legalEntities,
      ...localOptions.filter((entity) => !knownIds.has(entity.uuid)),
    ];
    return merged;
  }, [legalEntities, localOptions]);

  const handleDialogClose = () => setDialogOpen(false);

  const handleCreated = (beneficiary) => {
    if (beneficiary?.uuid) {
      setLocalOptions((prev) => [
        beneficiary,
        ...prev.filter((entity) => entity.uuid !== beneficiary.uuid),
      ]);

      onChange?.({
        target: {
          name,
          value: beneficiary.uuid,
        },
      });
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end', ...containerSx }}>
        <CustomAutoComplete
          label={label}
          name={name}
          value={value}
          onChange={onChange}
          error={error}
          helperText={helperText}
          disabled={disabled}
          required={required}
          sx={{ flex: 1, maxWidth: width, minWidth: width, ...selectSx }}
        >
          <MenuItem value="">{placeholder}</MenuItem>
          {mergedOptions.map((entity) => (
            <MenuItem key={entity.uuid} value={entity.uuid}>
              {getDisplayName(entity)}
            </MenuItem>
          ))}
        </CustomAutoComplete>

        <CustomButton
          variant="base"
          startIcon={<AddIcon />}
          onClick={() => setDialogOpen(true)}
          sx={{ whiteSpace: 'nowrap' }}
        >
          {'>'}
        </CustomButton>
      </Box>

      <BeneficiaryDialog open={dialogOpen} onClose={handleDialogClose} onCreated={handleCreated} />
    </>
  );
};

export default BeneficiarySelectWithCreate;
